import { Module } from '@models/module.model'
import API from '.'

const GetModuleList = async ({
	product_id,
	moduleId,
}: {
	product_id?: string
	moduleId?: string
}) => {
	let req: {
		product_ids?: any
		module_ids?: any
	} = {}
	if (product_id) {
		req['product_ids'] = {
			operator: '=',
			value: [product_id],
		}
	}

	if (moduleId) {
		req['module_ids'] = {
			operator: '=',
			value: [moduleId],
		}
	}

	return await API.post<{ data: Module[] }>(`/api/v2/modules/search`, req).then((rep) => {
		return rep.data
	})
}

const ModuleService = {
	GetModuleList,
}

export default ModuleService
